import type { AppsCopy } from "../types";

export const APPS_PT_BR: AppsCopy = {
  home: "Início",
  breadcrumb: "Apps",
  breadcrumbLabel: "Você está em",
  status: { published: "Disponível", comingSoon: "Em breve" },
  landing: {
    heading: "Apps da Codecious",
    lead: "Apps para o dia a dia: treino, alimentação e carreira em tecnologia. O Gymtero já está disponível; o Nutrinima e o Jobxtech estão em desenvolvimento.",
    viewDetails: "Ver detalhes",
    joinWaitlist: "Entrar na lista de espera",
    openWeb: "Abrir na web",
    playStoreAlt: "Disponível no Google Play",
  },
  apps: {
    gymtero: {
      category: "Treinos",
      summary:
        "Monte e organize seus treinos, registre cargas e acompanhe a sua evolução. Funciona offline, na web e no Android.",
      features: [
        "Planos de treino com progressão",
        "Registro de cargas, histórico e recordes pessoais",
        "Metas e conquistas",
        "Acompanhamento por personal trainer",
      ],
    },
    nutrinima: {
      category: "Alimentação",
      summary:
        "Assistente de hábitos alimentares. Está em desenvolvimento e ainda não pode ser baixado.",
      features: [
        "Registro de refeições por foto",
        "Painel de nutrientes",
        "Lembretes de hidratação",
      ],
    },
    jobxtech: {
      category: "Carreira tech",
      summary:
        "Plataforma de vagas e oportunidades em tecnologia. Está em desenvolvimento e ainda não está disponível.",
      features: ["Conecta profissionais de tecnologia a vagas"],
    },
  },
  comingSoon: {
    nutrinima: {
      lead: "O Nutrinima é o assistente de hábitos alimentares da Codecious. Ele está em desenvolvimento e ainda não pode ser baixado.",
      plannedTitle: "O que estamos construindo",
      planned: [
        "Registro de refeições por foto",
        "Painel de nutrientes",
        "Lembretes de hidratação",
      ],
      waitlistTitle: "Quer saber quando sair?",
      waitlistText:
        "Entre na lista de espera e avisamos por e-mail quando o Nutrinima for lançado.",
    },
    jobxtech: {
      lead: "O Jobxtech é a plataforma de vagas e oportunidades em tecnologia da Codecious. Ele vai conectar profissionais de tecnologia a vagas e está em desenvolvimento.",
      plannedTitle: "O que estamos construindo",
      planned: [],
      waitlistTitle: "Quer saber quando sair?",
      waitlistText:
        "Entre na lista de espera e avisamos por e-mail quando o Jobxtech for lançado.",
      note: {
        text: "É recrutador ou representa uma empresa?",
        linkLabel: "Conheça o Jobxtech para empresas",
        href: "/business#jobxtech",
      },
    },
  },
  backToApps: "Ver todos os apps",
  gymteroPage: {
    apkUnavailable:
      "O APK não está disponível no momento. Instale pelo Google Play ou tente de novo mais tarde.",
    moreTitle: "Conta e privacidade",
    links: {
      deleteAccount: "Como excluir sua conta",
      terms: "Termos de Uso",
      privacy: "Política de Privacidade",
    },
  },
};
